export default function reportInstanceDirective() {
  return {
    template: require('./report-instance.html'),
    controller: 'MRReportInstanceController',
    controllerAs: 'mrReportInstanceVM',
    bindToController: true,
    replace: true,
    scope: {
      customerId: '@',
      reportInstance: '=',
    },
  };
}
